import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "footer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Om företaget", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Här hittar du information om ditt företag.", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " Du hanterar dina e-tjänster och ansökningar i E-tjänsteportalen (öppnas i nytt fönster) ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", null, "Vanligaste e-tjänsterna", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { computed } from 'vue'
import customButton from '@/components/ui/custom-button.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'startpageLinks',
  props: {
  textClass: {
    type: Object
  },
  columnSizes: {
    type: Object
  },
  paddingClass: {
    type: String
  }
},
  setup(__props) {

const columnSizes = computed(() => {
  if (props.paddingClass !== 'xpadding-mobile') {
    return [5, 5]
  }
  return [12, 12] // Add a default return value here
})

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_footer = _resolveComponent("v-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_footer, {
      flat: "",
      app: "",
      absolute: "",
      class: "px-0 py-8"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, {
          fluid: "",
          class: _normalizeClass([__props.paddingClass, "bg-secondary"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: columnSizes.value[0],
                  class: "primaryRow pr-12"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", {
                      class: _normalizeClass(__props.textClass?.h2)
                    }, "Vad behöver du idag?", 2),
                    _hoisted_2,
                    _createVNode(customButton, {
                      text: 'Beslut, lov & tillstånd',
                      href: '/permits',
                      "ref-type": 'internalRoute'
                    }),
                    _hoisted_3,
                    _createVNode(customButton, {
                      text: 'Ärenden & tjänster',
                      href: '/case',
                      "ref-type": 'internalRoute'
                    }),
                    _hoisted_4,
                    _hoisted_5,
                    _hoisted_6,
                    _hoisted_7,
                    _createVNode(customButton, {
                      text: 'Företagsuppgifter',
                      href: '/companyinfo',
                      "ref-type": 'internalRoute'
                    }),
                    _hoisted_8,
                    _createVNode(customButton, {
                      text: 'Företagets fastigheter',
                      href: '/companyinfo',
                      "ref-type": 'internalRoute'
                    }),
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["cols"]),
                _createVNode(_component_v_col, {
                  cols: columnSizes.value[1],
                  class: "secondaryRow"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", {
                      class: _normalizeClass(__props.textClass?.h2)
                    }, "E-tjänster", 2),
                    _hoisted_10,
                    _hoisted_11,
                    _hoisted_12,
                    _createVNode(customButton, {
                      text: 'Slamtömning',
                      href: 'https://westro.se',
                      "ref-type": 'externalRoute'
                    }, null, 8, ["href"]),
                    _hoisted_13,
                    _createVNode(customButton, {
                      text: 'Komplettera ärende',
                      href: 'https://westro.se',
                      "ref-type": 'externalRoute'
                    }, null, 8, ["href"]),
                    _hoisted_14,
                    _createVNode(customButton, {
                      text: 'Bygglov, marklov, rivningslov',
                      href: 'https://westro.se',
                      "ref-type": 'externalRoute'
                    }, null, 8, ["href"]),
                    _hoisted_15,
                    _createVNode(customButton, {
                      text: 'Anmälan om utebliven sophämtning',
                      href: 'https://westro.se',
                      "ref-type": 'externalRoute'
                    }, null, 8, ["href"]),
                    _hoisted_16,
                    _createVNode(customButton, {
                      text: 'Små avlopp - ansökan/anmälan',
                      href: 'https://westro.se',
                      "ref-type": 'externalRoute'
                    }, null, 8, ["href"])
                  ]),
                  _: 1
                }, 8, ["cols"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    })
  ]))
}
}

})